var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('h1',[_vm._v(_vm._s(_vm.page.title))]),_c('AdvancedMarkdown',{staticClass:"my-4",attrs:{"source":_vm.page.content}}),_c('p',{staticClass:"text-muted"},[_vm._v("Posledná úprava: "+_vm._s(_vm.pageDate))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }